<div class="profile-image-card">
  <div class="image-circle" (click)="triggerFileInput(fileInput)">
    
    <img
      *ngIf="profileImage"
      [src]="profileImage"
      alt="Profile"
      (error)="onRemoveClick()"
    />

    <div *ngIf="!profileImage" class="default-icon">
      <i class="material-icons user-icon">person</i>
    </div>

    <input
      #fileInput
      type="file"
      accept="image/*"
      hidden
      (change)="onFileSelected($event)"
    />
  </div>

  <div class="image-actions">
    <button
      type="button"
      class="link-btn"
      (click)="triggerFileInput(fileInput)"
      [disabled]="uploading"
    >
      <div class="upload-btn">
        <wm-common-text
          [data]="{
            text: profileImage ? 'Change Profile Picture' : 'Upload Profile Picture'
          }"
        ></wm-common-text>
      </div>
    </button>

    <button
      type="button"
      class="link-btn remove"
      (click)="openRemovePhotoConfirm()"
      [disabled]="!profileImage || uploading"
    >
      <div class="upload-btn">
        <wm-common-text
          [data]="{ text: 'Remove Profile Picture' }"
        ></wm-common-text>
      </div>
    </button>
  </div>
</div>

<wm-common-confirmation-modal
  [data]="removePhotoModalData"
  (onYesClick)="confirmRemovePhoto()"
  (onNoClick)="closeRemovePhotoConfirm()"
>
</wm-common-confirmation-modal>
